export default __webpack_public_path__ + "static/media/icecream.31332a3c.svg";